import Reveal from "@/components/Reveal";

interface ModelItem {
  name: string;
  /** Tailwind classes for the icon tile background */
  tile: string;
  /** Inline SVG mark rendered inside the tile, or a CDN image URL */
  mark: React.ReactNode | string;
}

// Reusable WAN-style violet star (used for wan 2.7 image, wan 2.7 video, qwen image 2.0)
const WanStar = (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none">
    <path
      d="M12 2l2.4 5.6L20 8l-4.2 3.8L17 18l-5-3-5 3 1.2-6.2L4 8l5.6-.4L12 2z"
      fill="url(#wanGrad)"
    />
    <defs>
      <linearGradient id="wanGrad" x1="0" y1="0" x2="24" y2="24">
        <stop offset="0%" stopColor="#7c5cff" />
        <stop offset="100%" stopColor="#3b82f6" />
      </linearGradient>
    </defs>
  </svg>
);

const models: ModelItem[] = [
  {
    name: "nano banana 2",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/04a2ed2b-db35-4095-85a4-50edfb16346c.png",
  },
  {
    name: "imagegpt 2",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/9cec833b-6883-462b-b946-666fda026b9e.png",
  },
  { name: "wan 2.7 video", tile: "bg-transparent", mark: "https://cdn.pixro.ai/aceed311-9f76-4b5f-ad0a-c327b558b300.png" },
  {
    name: "eleven labs",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/bba966b6-12b5-4202-97f5-50b0b63035c0.png",
  },
  { name: "wan 2.7 image", tile: "bg-transparent", mark: "https://cdn.pixro.ai/1d07cd26-f9c7-4d09-8d32-993830331bff.png" },
  {
    name: "grok image",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/58afb164-a472-4328-b7c4-836cdcf2d39b.png",
  },
  {
    name: "veo 3",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/590310db-7935-476e-865f-168c9451787c.png",
  },
  {
    name: "heygen",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/6f0a547d-335d-43d9-bd20-b878ddc1de3c.png",
  },
  {
    name: "seeddream 4.5",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/41762f15-0350-4755-8529-54419a6e2b62.png",
  },
  {
    name: "luma ai",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/38f76e6a-bbb5-4d41-b811-0dcb8a563ac8.png",
  },
  {
    name: "hailuo ai",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/512630ec-4961-4647-91c4-cf7b1b2b5e09.png",
  },
  {
    name: "perplexity",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/685778da-6006-4b20-911c-8742f82388b1.png",
  },
  { name: "qwen image 2.0", tile: "bg-transparent", mark: "https://cdn.pixro.ai/83c0c4b0-0217-4b8e-9b58-da115ae4798c.png" },
  {
    name: "midjourney",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/4862dac9-81fa-463e-87e1-42f55f7cb4ca.png",
  },
  {
    name: "vidu ai",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/c0eb51cc-adcf-4fd9-bd9b-6ef71a3b6991.png",
  },
  {
    name: "claude ai",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/272a7b05-2fe2-4a50-808e-82865292b1d9.png",
  },
  {
    name: "flux 2.0",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/9c4c7aa8-9d9c-4ce4-bacc-9f396c4bb477.png",
  },
  {
    name: "seedance",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/cb6498f6-5f46-4596-8ab3-690ceffeff76.png",
  },
  {
    name: "pixeverse",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/e1de2469-61bc-4220-86ff-82c527b4b232.png",
  },
  {
    name: "suno ai",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/1a28f2b1-53bc-4dde-a724-ce9e4ff2781d.png",
  },
  {
    name: "topaz ai",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/6e76241e-2c97-460e-8c20-068bec8c3e0a.png",
  },
  {
    name: "kling 3.0",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/8fa20f8a-c1ab-4d3c-a21a-7e23af8f5bb5.png",
  },
  {
    name: "runway ml",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/f2dda151-5193-43a1-a7e1-aec93a386c94.png",
  },
  {
    name: "chatgpt",
    tile: "bg-transparent",
    mark: "https://cdn.pixro.ai/22634c71-3220-45b8-a451-b0e4a05ea209.png",
  },
];

const ModelsShowcase = () => {
  return (
    <section className="py-16 sm:py-24 bg-background">
      <div className="container mx-auto px-6 sm:px-8 md:px-[10%]">
        <Reveal variant="fade-up">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-foreground sm:text-4xl md:text-5xl">
              40+ models. Zero decisions.
            </h2>
            <p className="mt-4 mx-auto max-w-2xl text-muted-foreground leading-relaxed text-base sm:text-lg">
              Pixro understands what you're creating and picks the perfect model for it, every time.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-6 sm:gap-x-8 sm:gap-y-8">
          {models.map((model, i) => (
            <Reveal key={model.name} variant="fade-up" delay={i * 30}>
              <div className="flex items-center gap-3">
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-[6px] shadow-sm ring-1 ring-black/5 ${model.tile}`}
                >
                  {typeof model.mark === "string" ? (
                    <img
                      src={model.mark}
                      alt={`${model.name} icon`}
                      className="h-full w-full object-contain"
                    />
                  ) : (
                    model.mark
                  )}
                </div>
                <span className="text-sm sm:text-base font-medium text-foreground">
                  {model.name}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModelsShowcase;
